import React, { useCallback, useEffect, useMemo, useState } from "react";
import { MdOutlinePhotoLibrary } from "react-icons/md";
import HeroThumbsSlider from "../HeroThumbsSlider/HeroThumbsSlider";
import HeroGalleryLightbox from "../HeroGalleryLightbox/HeroGalleryLightbox";

export default function HotelOfferSaleGallery({
  images = [],
  hotelName = "",
  maxImages = 24,
}) {
  const galleryImages = useMemo(() => {
    const list = Array.isArray(images) ? images.filter(Boolean) : [];
    return list.slice(0, maxImages);
  }, [images, maxImages]);

  const [activeIndex, setActiveIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  useEffect(() => {
    setActiveIndex(0);
  }, [galleryImages.length, galleryImages[0]]);

  const activeImage = galleryImages[activeIndex] || null;

  const goToImage = useCallback(
    (delta) => {
      if (galleryImages.length <= 1) return;
      setActiveIndex((idx) => (idx + delta + galleryImages.length) % galleryImages.length);
    },
    [galleryImages.length]
  );

  return (
    <section
      className="orderSummery-guest-sale-card orderSummery-guest-sale-gallery"
      aria-label="גלריית המלון"
    >
      <header className="orderSummery-guest-sale-section-head">
        <h3>גלריית תמונות</h3>
        <span>
          <MdOutlinePhotoLibrary aria-hidden />
          {galleryImages.length || 1} תמונות
        </span>
      </header>

      <div className="orderSummery-guest-sale-gallery-stage">
        {activeImage ? (
          <button
            type="button"
            className="orderSummery-guest-sale-gallery-main-btn"
            onClick={() => galleryImages.length > 0 && setLightboxOpen(true)}
            aria-label="פתיחת צפייה מלאה בגלריה"
          >
            <img src={activeImage} alt={hotelName || "תמונת מלון"} />
          </button>
        ) : (
          <div className="orderSummery-guest-sale-gallery-placeholder" aria-hidden />
        )}

        {galleryImages.length > 1 ? (
          <>
            <button
              type="button"
              className="orderSummery-guest-sale-gallery-nav orderSummery-guest-sale-gallery-nav--prev"
              onClick={() => goToImage(-1)}
              aria-label="תמונה קודמת"
            >
              ‹
            </button>
            <button
              type="button"
              className="orderSummery-guest-sale-gallery-nav orderSummery-guest-sale-gallery-nav--next"
              onClick={() => goToImage(1)}
              aria-label="תמונה הבאה"
            >
              ›
            </button>
          </>
        ) : null}
      </div>

      {galleryImages.length > 1 ? (
        <HeroThumbsSlider
          wrapperClassName="orderSummery-guest-sale-gallery-thumbs-outer"
          trackClassName="orderSummery-guest-sale-gallery-thumbs"
          ariaTrackLabel="בחירת תמונה"
        >
          {galleryImages.map((img, index) => (
            <button
              key={`${img}-${index}`}
              type="button"
              className={
                "orderSummery-guest-sale-gallery-thumb" +
                (index === activeIndex ? " is-active" : "")
              }
              onClick={() => setActiveIndex(index)}
              aria-label={`תמונה ${index + 1}`}
            >
              <img src={img} alt="" loading={index === 0 ? "eager" : "lazy"} />
            </button>
          ))}
        </HeroThumbsSlider>
      ) : null}

      <HeroGalleryLightbox
        open={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        images={galleryImages}
        startIndex={activeIndex}
        onExit={(idx) => setActiveIndex(idx)}
        hotelName={hotelName || ""}
      />
    </section>
  );
}
